import React from 'react'
import Select from 'react-select'
import CustomOptions from '@components/select/CustomOptions'

function AdvanceSelect(props) {
  const colourStyles = {
    control: (styles) => ({ ...styles, backgroundColor: 'var(--surface-bg)' }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => ({
      ...styles,
      color: 'var(--text-heading)'
    }),
    input: (styles) => ({ ...styles }),
    placeholder: (styles) => ({ ...styles }),
    singleValue: (styles, { data }) => ({ ...styles }),
    multiValue: (styles, { data }) => ({ ...styles, backgroundColor: 'var(--color-primary)' }),
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: 'white'
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: 'white',
      ':hover': {
        backgroundColor: 'var(--color-secondary)',
        color: 'white'
      }
    })
  }

  return <Select {...props} styles={colourStyles} />
}

export default AdvanceSelect
